<template>
  <div>
    <loading
      :active.sync="alerts_table.requestLoading"
      :is-full-page="false"
    />
    <div
      data-cy="alert_table"
    >
      <v-server-table
        ref="alerts_table"
        :name="'alerts/alertsTable' + _uid"
        :columns="alerts_table.columns"
        :options="alerts_table_options"
        @loading="alerts_table.requestLoading = true"
        @loaded="alerts_table.requestLoading = false"
      >
        <div
          slot="service_id"
          slot-scope="props"
        >
          {{ props.row.service_id }}
        </div>
        <div
          slot="create_date"
          slot-scope="props"
        >
          <DateFormat
            :date="props.row.create_date"
            :showtime="true"
          />
        </div>
        <div
          slot="hit_name"
          slot-scope="props"
        >
          {{ props.row.hit_name }}
        </div>
        <!-- <div slot="hit_status" slot-scope="props">{{ parseInt(props.row.hit_status) == 1 ? 'True Hit' : (parseInt(props.row.hit_status) == 2 ? 'False Hit' : 'Pending' )  }}</div> -->
        <div
          slot="hit_status"
          slot-scope="props"
        >
          {{ (hit_status_options.find(x => x.value == props.row.hit_status) || { text: '' }).text }}
        </div>
        <div
          slot="exposition"
          slot-scope="props"
          style="max-width: 300px;"
        >
          {{ (exposition_options(props.row.hit_status).find(x => x.value == props.row.exposition) || { text: '' }).text }}
        </div>
        <div
          slot="remarks"
          slot-scope="props"
        >
          <TextareaSafeDisplay :value="props.row.remarks" />
        </div>
        <div
          slot="action"
          slot-scope="props"
        >
          <v-btn
            icon
            @click="popup_alert_detail(props.row);"
          >
            <v-icon>{{ props.row.hit_status == 0 ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
          </v-btn>
        </div>
      </v-server-table>
    </div>
    <v-dialog
      v-model="dialog_alert_detail"
      max-width="90%"
    >
      <v-card>
        <PopupAlertDetail
          :records="dialog_alert_detail_record"
          @onSave="(form) => {
            $refs.alerts_table.getData()
            dialog_alert_detail = false;
            dialog_alert_detail_record = null;
          }"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PopupAlertDetail from '@/components/popups/PopupAlertDetail'
import DateFormat from '@/components/common/DateFormat'

export default {
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    PopupAlertDetail,
    DateFormat
  },
  computed: {
    ...mapGetters({
      hit_status_options: 'alerts/hit_status_options',
      exposition_options: 'alerts/exposition_options'
    }),
    alerts_table_options () {
      return {
        requestFunction: (request) => {
          if (!this.companyId) {
            return false
          }

          clearTimeout(this.alerts_table.requestTimeout)
          return new Promise((resolve, reject) => {
            this.alerts_table.requestTimeout = setTimeout(async () => {
              try {
                var criteria = {
                  // params: {
                  // where: request.query, // Todo: parse where query
                  where: (((query) => {
                    var _where = { company: this.companyId }

                    if (query.hit_name) _where.hit_name = { contains: query.hit_name }
                    if (query.id) _where.id = query.id
                    if (query.service_id) _where.service_id = { contains: query.service_id }
                    if (query.exposition) _where.exposition = { contains: query.exposition }
                    if (query.remarks) _where.remarks = { contains: query.remarks }
                    if (query.hit_status != null) _where.hit_status = query.hit_status
                    if (query.create_date) { // _where.create_date = query.create_date
                      _where.and = [
                        { create_date: { '>': this.moment(query.create_date.start).valueOf() } },
                        { create_date: { '<': this.moment(query.create_date.end).valueOf() } }
                      ]
                    }

                    return _where
                  })(request.query)),
                  sort: request.orderBy ? `${request.orderBy} ${request.ascending === 1 ? 'ASC' : 'DESC'}` : 'create_date DESC', // Todo: parse sort query
                  limit: request.limit,
                  skip: request.limit * (request.page - 1)
                  // }
                }
                var count = await this.$store.dispatch('alerts/count', criteria)
                var results = await this.$store.dispatch('alerts/findWhere', criteria)

                resolve({ data: results.data, count: count.data.count }) // https://matanya.gitbook.io/vue-tables-2/server-table
              } catch (error) {
                console.log('Alerts History: ' + error)
                reject(error)
              }
            }, 800)
          })
        },
        columnsClasses: {
          id: 'col-xs-1',
          service_id: 'col-xs-1',
          create_date: 'col-xs-1',
          hit_name: 'col-xs-2',
          hit_status: 'col-xs-1',
          exposition: 'col-xs-3',
          // remarks: 'col-xs-3',
          action: 'col-xs-1'
        },
        sortable: ['id', 'service_id', 'create_date', 'hit_name', 'hit_status', 'exposition'],
        headings: {
          id: this.$t('alert.details.form.id.label'),
          service_id: this.$t('alert.details.form.service_id.label'),
          hit_name: this.$t('alert.details.form.hit_name.label'), // 'Company Name',
          hit_status: this.$t('alert.details.form.hit_status.label'), // 'Status',
          create_date: this.$t('alert.details.form.create_date.label'), // 'Date Created',
          updated_date: this.$t('alert.details.form.updated_date.label'), // 'Date Updated',
          exposition: this.$t('alert.details.form.exposition.label'),
          action: this.$t('listing.table.action.label')
        },
        // sortable: [],
        filterable: ['id', 'service_id', 'create_date', 'hit_name', 'hit_status', 'exposition'],
        filterByColumn: true,
        dateColumns: ['create_date'],
        // dateFormat: 'DD/MMM/YYYY',
        // datepickerOptions: {
        // 	// alwaysShowCalendars: true,
        // 	ranges: {
        // 		[this.$t('listing.table.datepicker.today')]: [moment(), moment()],
        // 		[this.$t('listing.table.datepicker.yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        // 		[this.$t('listing.table.datepicker.last_n_days', { num_of_days: 7 })]: [moment().subtract(6, 'days'), moment()],
        // 		[this.$t('listing.table.datepicker.last_n_days', { num_of_days: 30 })]: [moment().subtract(29, 'days'), moment()],
        // 		[this.$t('listing.table.datepicker.this_month')]: [moment().startOf('month'), moment().endOf('month')],
        // 		[this.$t('listing.table.datepicker.last_month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        // 	}
        // },
        texts: {
          count: this.$t('listing.table.texts.count'),
          first: this.$t('listing.table.texts.first'),
          last: this.$t('listing.table.texts.last'),
          filter: this.$t('listing.table.texts.filter'),
          filterPlaceholder: this.$t('listing.table.texts.filterPlaceholder'),
          limit: this.$t('listing.table.texts.limit'),
          page: this.$t('listing.table.texts.page'),
          noResults: this.$t('listing.table.texts.noResults'),
          noRequest: this.$t('listing.table.texts.noRequest'),
          filterBy: this.$t('listing.table.texts.filterBy'),
          loading: this.$t('listing.table.texts.loading'),
          defaultOption: this.$t('listing.table.texts.defaultOption'),
          columns: this.$t('listing.table.texts.columns')
        },
        listColumns: {
          hit_status: [
            {
              id: 0,
              text: this.$t('alert.details.form.hit_status.options')[0]// 'Pending'
            },
            {
              id: 1,
              text: this.$t('alert.details.form.hit_status.options')[1] // 'True hit',
            },
            {
              id: 2,
              text: this.$t('alert.details.form.hit_status.options')[2] // 'False hit',
            }
          ]
        }
        // see the options API
      }
    }
  },
  data () {
    return {
      alerts_table: {
        requestTimeout: null,
        requestLoading: false,
        columns: ['id', 'service_id', 'create_date', 'hit_name', 'hit_status', 'exposition', /* 'remarks', */'action']
      },
      dialog_alert_detail: false,
      dialog_alert_detail_record: null
    }
  },
  methods: {
    popup_alert_detail (row) {
      this.dialog_alert_detail_record = row
      this.dialog_alert_detail = true
    }
  }
}
</script>

<style>
</style>
